import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import Footer from '@/components/feature/Footer';
import { BRAND_LOGO } from '@/constants/brand';

type LegalLayoutProps = {
  eyebrow?: string;
  title: string;
  subtitle?: string;
  children: ReactNode;
};

export default function LegalLayout({
  eyebrow = 'Rechtliches',
  title,
  subtitle,
  children,
}: LegalLayoutProps) {
  return (
    <main className="bg-background-50 min-h-screen">
      <header className="sticky top-0 z-50 bg-background-50 border-b border-background-200">
        <div className="w-full px-4 md:px-6">
          <div className="mx-auto max-w-7xl h-24 md:h-28 flex items-center justify-between gap-4">
            <Link to="/" className="flex items-center shrink-0 cursor-pointer">
              <img
                src={BRAND_LOGO}
                alt="Ganzheitliche Persönlichkeitsentwicklung – Stephanie Wolf"
                title="Stephanie Wolf – Ganzheitliche Persönlichkeitsentwicklung"
                className="h-16 md:h-20 w-auto"
              />
            </Link>
            <Link
              to="/"
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-full border border-background-300 text-foreground-800 px-5 py-2.5 text-sm font-semibold hover:bg-background-100 transition-colors cursor-pointer"
            >
              <i className="ri-arrow-left-line text-base"></i>
              Zur Startseite
            </Link>
          </div>
        </div>
      </header>

      <section className="bg-primary-500 text-background-50">
        <div className="mx-auto max-w-4xl px-4 md:px-6 py-14 md:py-20 text-center">
          <p className="text-xs md:text-sm font-semibold uppercase tracking-[0.2em] text-background-50/80">
            {eyebrow}
          </p>
          <h1 className="mt-4 text-3xl md:text-5xl font-bold leading-tight">{title}</h1>
          {subtitle && (
            <p className="mt-4 max-w-2xl mx-auto text-sm md:text-base text-background-50/90">
              {subtitle}
            </p>
          )}
        </div>
      </section>

      <section className="mx-auto max-w-4xl px-4 md:px-6 py-14 md:py-20">
        <div className="rounded-lg border border-background-200 bg-background-50 p-6 md:p-10">
          <div className="space-y-10">{children}</div>
        </div>
      </section>

      <Footer />
    </main>
  );
}